export default __webpack_public_path__ + "static/carousel-8-0f84fc885797436ad673d379b8da9675.jpg";